(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("eardrum", [], factory);
	else if(typeof exports === 'object')
		exports["eardrum"] = factory();
	else
		root["eardrum"] = factory();
})(this, function() {
return 